import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import logo from "../assets/images/logo.png";

const NavigationBar = () => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [quoteType, setQuoteType] = useState("Product Quote");

  const handleQuoteSubmit = () => {
    const message = `Hello Vigneshwara Power Controls,

I would like to get a ${quoteType}.

Please provide me with more details.`;

    window.open(
      `https://wa.me/917396748509?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    setShowQuoteModal(false);
  };

  const handleDownloadCatalogue = () => {
    const link = document.createElement("a");
    link.href = "/pdfs/cat.pdf";
    link.download = "Vigneshwara_Power_Controls_Catalogue.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scrollToSection = (id) => {
  document.getElementById(id).scrollIntoView({
    behavior: "smooth"
  });
};

  useEffect(() => {
    document.body.style.overflow = showQuoteModal ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showQuoteModal]);

  const quoteOptions = [
    "Product Quote",
    "Project Quote",
    "Service Quote",
    "Custom Quote",
  ];

  return (
    <>
      {/* ===================== STYLES ===================== */}
      <style>{`
        .main-nav {
          background: #ffffff;
          box-shadow: 0 2px 15px rgba(0,0,0,0.1);
          position: sticky;
          top: 0;
          z-index: 1001;
          padding: 10px 0;
        }

        .nav-container {
          padding: 0 20px;
        }

        .nav-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .logo-section {
          display: flex;
          align-items: center;
          gap: 15px;
          cursor: pointer;
        }

        .logo-image {
          height: 45px;
          object-fit: contain;
        }

        .company-name-wrapper {
          display: flex;
          flex-direction: column;
        }

        .company-name {
          font-size: 15px;
          font-weight: 900;
          color: #d32f2f;
          text-transform: uppercase;
        }

        .company-tagline {
          font-size: 11px;
          color: #666;
        }

        .nav-actions {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .catalogue-btn {
          background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
          color: #fff;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: 0.3s ease;
        }

        .catalogue-btn:hover {
          transform: translateY(-1px);
        }

        .quote-btn {
          background: linear-gradient(135deg, #27ae60 0%, #219653 100%);
          color: #fff;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: 0.3s ease;
        }

        .quote-btn:hover {
          transform: translateY(-1px);
        }

        /* MODAL */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
        }

        .modal-content {
          background: #fff;
          padding: 30px;
          border-radius: 12px;
          width: 90%;
          max-width: 400px;
        }

        .modal-content h3 {
          text-align: center;
          margin-bottom: 20px;
        }

        .quote-option {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px;
          margin-bottom: 10px;
          background: #f8f9fa;
          border-radius: 6px;
          cursor: pointer;
        }

        .modal-actions {
          display: flex;
          gap: 10px;
          margin-top: 20px;
        }

        .modal-btn {
          flex: 1;
          padding: 10px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
          font-weight: 600;
        }

        .modal-btn.submit {
          background: #27ae60;
          color: white;
        }

        .modal-btn.cancel {
          background: #e0e0e0;
        }

        @media (max-width: 768px) {
          .company-name {
            font-size: 12px;
          }

          .company-tagline {
            font-size: 9px;
          }

          .logo-image {
            height: 38px;
          }

          .catalogue-btn span,
          .quote-btn span {
            display: none;
          }

          .catalogue-btn,
          .quote-btn {
            padding: 8px;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            justify-content: center;
          }
        }
      `}</style>

      {/* ===================== NAVBAR ===================== */}
      <nav className="main-nav">
        <Container className="nav-container">
          <div className="nav-content">

            {/* Logo */}
            <div
              className="logo-section"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={logo} alt="VPC Logo" className="logo-image" />
              <div className="company-name-wrapper">
                <div className="company-name">
                  Vigneshwara Power Controls
                </div>
                <div className="company-tagline">
                  Manufacturing and Services
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="nav-actions">
              <button
                className="quote-btn"
                onClick={() => setShowQuoteModal(true)}
              >
                <i className="fas fa-comment-dots"></i>
                <span>Get Quote</span>
              </button>

              <button
                className="catalogue-btn"
                onClick={handleDownloadCatalogue}
              >
                <i className="fas fa-download"></i>
                <span>Download Catalogue</span>
              </button>
            </div>

          </div>
        </Container>
      </nav>

      {/* ===================== QUOTE MODAL ===================== */}
      {showQuoteModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowQuoteModal(false)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Select Quote Type</h3>

            {quoteOptions.map((option) => (
              <label key={option} className="quote-option">
                <input
                  type="radio"
                  checked={quoteType === option}
                  onChange={() => setQuoteType(option)}
                />
                {option}
              </label>
            ))}

            <div className="modal-actions">
              <button
                className="modal-btn cancel"
                onClick={() => setShowQuoteModal(false)}
              >
                Cancel
              </button>
              <button
                className="modal-btn submit"
                onClick={handleQuoteSubmit}
              >
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NavigationBar;